const baseKey = '/v1/trader/statistics/'

export const requisiteStatisticApi = {
  getTotalStat: (queryParams: string) => `${baseKey}/requisit/total?${queryParams}`,
  getDailyStat: (queryParams: string) => `${baseKey}/requisit/daily?${queryParams}`,
  getPaymentReqTotal: (queryParams: string) => `${baseKey}/paymentrequisit/total?${queryParams}`,
  getPaymentReqDaily: (queryParams: string) => `${baseKey}/paymentrequisit/daily?${queryParams}`,
}
